import { ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Activity, ActivityType } from '@omni/classes/activity/activity.class';
import { FOLLOW_UP_TYPE, FollowUpActivity } from '@omni/classes/activity/follow-up-action.activity.class';
import { ProcedureTrackerActivity } from '@omni/classes/activity/procedure-tracker.activity.class';
import { SurgeryOrderActivity } from '@omni/classes/activity/surgery-order.activity.class';
import { SetBookingActivity } from '@omni/classes/activity/set-booking.activity.class';
import { IAllocationAdjustment } from '@omni/interfaces/allocation/allocation-adjustment.interface';
import { IAllocationShipment, IAllocationShipmentAndTransferBase, IAllocationShipmentBase } from '@omni/interfaces/allocation/allocation-shipment.interface';
import { IAllocationTransfer } from '@omni/interfaces/allocation/allocation-transfer.interface';
import { IndSectionHeaderViewDataModel } from '@omni/models/indSectionHeaderDataModel';
import { MainCardViewDataModel } from '@omni/models/MainCardViewDataModel';
import { ActivityService } from '@omni/services/activity/activity.service';
import { AgendaPlanListService, PlanTabActivityType } from '@omni/services/agenda-plan-list/agenda-plan-list.service';
import { AuthenticationService } from '@omni/services/authentication.service';
import { EventsService } from '@omni/services/events/events.service';
import { BehaviorSubject, debounceTime, Subject, Subscription, takeUntil } from 'rxjs';
import { TimeOffActivity } from '@omni/classes/activity/timeoff.class';
import { SampleActivity } from '@omni/classes/activity/sample.activity.class';
import { CaseActivity } from '@omni/classes/case-intake/case-activity.class';
import { EmailActivity, EmailViewType } from '@omni/classes/activity/email.activity.class';
import { PhoneActivity } from '@omni/classes/activity/phone.activity.class';
import { DatePipe } from '@angular/common';
import { DateTimeFormatsService } from '@omni/services/date-time-formats/date-time-formats.service';
import { OrderActivity } from '@omni/classes/activity/order.activity.class';
import { TransferType } from '@omni/enums/allocation/allocation.enum';
import { SecondaryInfoEntityName } from '@omni/classes/sec-info-config/sec-info.class';
import { FollowUpActivityDataService } from '@omni/data-services/follow-up-activity/follow-up-activity.data.service';
import { SecInfoConfigDataService } from '@omni/data-services/sec-info-config/sec-info-config-data-service';
import { AllocationShipmentService } from '@omni/services/sample/allocation-shipment.service';
import { ActivityDataService } from '@omni/data-services/activity/activity.service';
import { EmailService } from '@omni/services/email-templates/email.service';
import { COACHING_VIEW_TYPE, CoachingReportService } from '@omni/services/coaching/coaching.report.service';
import { FeatureActionsMap } from '@omni/classes/authentication/user.class';
import { Utility } from '@omni/utility/util';
import { GlobalUtilityService } from '@omni/services/global-utility.service';
import { AccesingMode, CaseManagementService } from '@omni/services/case-management/case-management.service';
import { NavigationService, PageName } from '@omni/services/navigation/navigation.service';
import { UIService } from '@omni/services/ui/ui.service';
import { TimeOffService } from '@omni/services/time-off/time-off.service';
import { Report } from '@omni/classes/coaching/report.class';
import { AllocationFeatureService } from '@omni/services/sample/allocation.feature.service';
import { DeltaService } from '@omni/data-services/delta/delta.service';
import { cloneDeep, isEmpty } from 'lodash-es';

@Component({
  selector: 'go-app-todo',
  templateUrl: './go-app-todo.html',
  styleUrl: './go-app-todo.scss',
  // OnPush deferred — deltaService.isInitialSyncFinished (no observable, set externally after sync/offline load)
  // and heavy event-driven data loading (20+ event subscriptions) would all need markForCheck() calls.
  // Previously reverted from OnPush due to async data loading issues.
})
export class GoAppTodoComponent {
  pinnedSectionHeader: IndSectionHeaderViewDataModel;

  allTodoItems = [];
  filteredTodoItems = [];

  private itemExpandHeight: number = 25;

  private visibleCount: number = 0;
  private ngDestroy$ = new Subject<boolean>();

  showSearch: boolean = false;
  searchText: string = '';

  @Output() activityOpenedFromTodo = new EventEmitter<boolean>();
  filterOptions: { id: string, name: string, selected: boolean }[] = [];
  allPossibleFilterOptions: { id: string, name: string, selected: boolean }[] = [];
  coachingActivities: Report[] = [];
  coachingSubscription: Subscription;
  private twoArgumentEventSubscriptions: { unsubscribe: Function }[] = [];

  // Reactive data source for virtual-list
  public todoItems$ = new BehaviorSubject<any[]>(null);
  // Viewport items updated by virtual-list
  viewPortItems: any[] = [];

  @ViewChild('todoList') todoList: any;

  constructor(public translate: TranslateService,
    public todoService: AgendaPlanListService,
    private authService: AuthenticationService,
    private events: EventsService,
    private activityService: ActivityService,
    private datePipe: DatePipe,
    private dateTimeFormatService: DateTimeFormatsService,
    private followUpDataService: FollowUpActivityDataService,
    private activityDataService: ActivityDataService,
    private shipmentService: AllocationShipmentService,
    private emailService: EmailService,
    private secInfoConfigDataService: SecInfoConfigDataService,
    public coachingReportService: CoachingReportService,
    private utilityService: GlobalUtilityService,
    private _ngZone: NgZone,
    private navService: NavigationService,
    private caseManagementService: CaseManagementService,
    public uiService: UIService,
    public timeOffService: TimeOffService,
    private allocFeatureService: AllocationFeatureService,
    public deltaService: DeltaService,
    private readonly _cd: ChangeDetectorRef,
  ) {
  }

  public trackByFilterId(index: number, option: any): string {
    return option?.id ?? index;
  }

  ngOnInit() {
    this.events.observe('refreshAgenda')
      .pipe(
        takeUntil(this.ngDestroy$),
        debounceTime(500),
      ).subscribe(() => {
        this.initTodoItems();
      });


      
    let translatedglobaltext;
    switch (this.utilityService.globalCustomerText) {
      case 'Customer':
        translatedglobaltext = this.translate.instant('CUSTOMER');
        break;
      case 'Stakeholder':
        translatedglobaltext = this.translate.instant('STAKEHOLDER');
        break;
      default:
        translatedglobaltext = this.utilityService.globalCustomerText;
        break;
    }
    this.coachingSubscription = this.coachingReportService.myReportSubject.subscribe((value) => {
      if (value.length > 0) {
        const todayStart = new Date(new Date().setHours(0, 0, 0, 0));
        this.coachingActivities = value.filter((item) => (item.statuscode === 548910002 || item.statuscode === 548910001) && new Date(item.indskr_periodstartdate) >= todayStart);
      }
    });

    this.events.observe('sync:completed').pipe(takeUntil(this.ngDestroy$)).subscribe(() => {
      this.searchText = '';
      this.showSearch = false;
      this.initFilterOptions(translatedglobaltext);
      this.initTodoItems();
    })

    this.events.observe('initTodo')
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe(() => {
        this.initTodoItems();
      });

    this.initAllSectionHeader();
    this.initFilterOptions(translatedglobaltext);
    this.initTodoItems();
    this.initPinnedItemsData();
    this.handleEvents()
  }

  private handleEvents() {
    //Surgery order
    this.surgeryOrderEvents();

    //Message
    this.messageEvents();

    //Allocation orders
    this.allocationOrdersEvents();

    //Timeoff
    this.timeOffEvents();

    //NewActivity
    this.events.observe('newActivityIsCreatedUpdatePlanTab').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.initTodoItems();
      this.onFilterClick();
    });

    //PhoneCall 
    this.phoneCallEvents();

    //Followup
    this.followupEvents();

    //Meeting
    this.meetingEvents();

    //Customer Inquiry
    this.customerInquiryEvents();

    //Sales Order
    this.salesOrderEvents();

    //Shipments and Transfers
    this.shipmentEvents();

    //Coaching
    this.coachingEvents();
  }

  private coachingEvents() {
    this.events.observe('coaching-updated').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: Report) => {
    
      let coachingActivitiesIndex = this.coachingActivities.findIndex(item => item._id === activity._id);
      if (coachingActivitiesIndex > -1) {
        this.coachingActivities.splice(coachingActivitiesIndex, 1);
      }

      let foundIndex = this.allTodoItems.findIndex(card => card._id === activity._id);
      if (foundIndex > -1) {
        this.allTodoItems.splice(foundIndex, 1);
        this.refreshTodoItems();
        this.coachingReportService.selectedReport.next(null);
        this.coachingReportService.selectedCoachingPlanTab = null;
        this.navService.setChildNavRightPaneView(false);
        this.resetRightSideView();
      }
    });
  }

  private shipmentEvents() {
    this.events.observe('shipmentAcknowledged')
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe((shipment: IAllocationShipmentBase) => {
        if (shipment.indskr_transfertype !== TransferType.AllocationAdjustment) {
          // Since it is not pinned Item we have to filter out from here
          const index = this.allTodoItems.findIndex(card => card.indskr_usershipmentallocation_v2id === shipment.indskr_usershipmentallocation_v2id);
          if (index > -1) {
            this.allTodoItems.splice(index, 1);
            // Unset selected shipment if ack was done on plan list view
            this.setSelectedShipmentAsUndefined();
          }

          this.onFilterClick();
          this.resetRightSideView();
        }
      });

    this.events.observe('closeShipmentDetail').pipe(takeUntil(this.ngDestroy$)).subscribe(() => {
      this.setSelectedShipmentAsUndefined();
    })
  }

  private setSelectedShipmentAsUndefined() {
    this.allocFeatureService.selectedShipment = undefined;
    this.allocFeatureService.selectedShipmentAtHome = undefined;
  }

  private salesOrderEvents() {
    this.events.observe('updateOrdersList').pipe(takeUntil(this.ngDestroy$)).subscribe((params: any) => {
      if (params.mode && params.mode === 'delete') {
        this.handleSalesOrderScrap(params.activity);
      } else {
        this.handleSalesOrderComplete(params.activity);
      }
    });
  }

  private handleSalesOrderScrap(activity) {

    if (activity) {
      const isIncompleteSalesOrder = this.allTodoItems.findIndex(({ ID }) => ID === activity.ID);

      if (isIncompleteSalesOrder >= 0) { // Incomplete Activity
        this.handleTodoItemTransactions(activity);
      }
    } else {
      this.todoService.triggerPendingActionDataRefresh$.next(true);
    }
  }

  private handleSalesOrderComplete(activity) {
    const isIncompleteSalesOrder = this.allTodoItems.findIndex(({ ID }) => ID === activity.ID);

    if (isIncompleteSalesOrder >= 0) {

      //Incomplete Activities
      // Here explicitely We do not need to handle the unpinning as it's already handled inside the Meeting transation method
      this.handleTodoItemTransactions(activity);
      this.resetRightSideView();
    }
  }

  private customerInquiryEvents() {
    this.twoArgumentEventSubscriptions.push(...this.events.subscribe('customerInquiryActivityDeleted', (activity, isFromParentActivity) => {
      this.handleTodoItemTransactions(activity, this.validateShouldResetRightSideView(isFromParentActivity));
    }));

    this.events.observe('customerInquiryActivitySubmitted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.handleTodoItemTransactions(activity);
      this.resetRightSideView();
    });

    this.events.observe('customerInquiryActivityIsUpdated').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.replaceUpdatedActivityOnChange(activity);
    });

    this.events.observe('customerInquiryActivityOpen').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      if (activity) {
        this.openActivityDetails(activity);
      }
    });
  }

  private meetingEvents() {
    this.events.observe('activityDeleted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => { this.handleTodoItemTransactions(activity); });

    this.events.observe('meetingCompleted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: Activity) => {
      this.handleTodoItemTransactions(activity);
      this.resetRightSideView();
    });

    this.events.observe('meetingCancelled').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: Activity) => {
      const index = this.allTodoItems.findIndex(card => card.ID === activity.ID);
      if (index > -1) {
        this.allTodoItems.splice(index, 1);
      }
      this.resetRightSideView();
    });

    this.events.observe('meetingReopened').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => { this.handleActivityReopened(activity); });

    this.events.observe('aciviiyCreatedRefreshTODO').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.refreshAgendaPlanList(activity);

      if (activity?.type === ActivityType.FollowUp) {
        let todayStart = new Date(new Date().setHours(0, 0, 0, 0));
        if (activity?.scheduledStart >= todayStart) {
          this.initTodoItems();
        }
      }

    });

  }

  private refreshAgendaPlanList(activity: any) {

    let meetingDateAdjustedWithGracePeriod = new Date(new Date((new Date().setDate(new Date().getDate() - this.authService.user.offlineDataDuration))).setHours(0, 0, 0, 0));

    let todayStart = new Date(new Date().setHours(0, 0, 0, 0));


    // Is within Raneg does covers the equal dates so having anither condition to make sure we are checking on the date
    if (this.dateTimeFormatService.isDateWithinRange(activity?.scheduledStart, meetingDateAdjustedWithGracePeriod, todayStart) && todayStart > activity?.scheduledStart) {
      //fit for incomplete activities'
      let index = this.allTodoItems.findIndex(o => o.ID === activity?.ID);
      if (index > -1) {
        this.allTodoItems[index] = activity;
      } else {
        this.allTodoItems.push(activity);
      }
    }
    this.onFilterClick();
  }

  private followupEvents() {
    this.events.observe('followupActionDeleted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      if (activity) {
        let todayStart = new Date(new Date().setHours(0, 0, 0, 0));
        if (todayStart > activity.scheduledStart) { // Incomplete Activity
          this.handleTodoItemTransactions(activity);
        } else {
          const index = this.allTodoItems.findIndex(card => card.ID === activity.ID);
          if (index > -1) {
            this.allTodoItems.splice(index, 1);
          }
          this.refreshTodoItems();
        }
      } else {
        this.todoService.triggerPendingActionDataRefresh$.next(true);
      }
    });

    this.events.observe('followupActionCancelled').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      if (activity) {
        this.handleTodoItemTransactions(activity);
        this.resetRightSideView();
      }
    });

    this.events.observe('followupTask:assignmentHistoryUpdated').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.handleTodoItemTransactions(activity);
    });

    // this is especially for folllow ups when due date is updated to teh future date, thsi has to be removed from incomplete activities and put that to pending actoions.
    this.events.observe('activityUpdated').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.updateFollowupPendingAction(activity);
    });

    this.events.observe('followupactioncompleted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {

      let todayStart = new Date(new Date().setHours(0, 0, 0, 0));


      if (todayStart > activity.scheduledStart) {

        //Incomplete Activities
        // Here explicitely We do not need to handle the unpinning as it's already handled inside the Meeting transation method
        this.handleTodoItemTransactions(activity);
      } else {
        // pending Actions
        const foundIndex = this.allTodoItems.findIndex(card => card.ID === activity.ID);
        if (foundIndex > -1) { //Found the index of the activity being completed.
          this.allTodoItems.splice(foundIndex, 1);
          this.refreshTodoItems();
        }
      }
      this.resetRightSideView();

    });
  }

  private updateFollowupPendingAction(activity: any) {
    let todayStart = new Date(new Date().setHours(0, 0, 0, 0));
    if (activity.type === ActivityType.FollowUp && todayStart <= activity.scheduledStart) { //// Pending Action is to be updated
      let index = this.allTodoItems.findIndex(card => card.ID === activity.ID);
      if (index > -1) {
        this.allTodoItems[index] = activity;
        this.refreshTodoItems();
      }
    }
  }

  resetRightSideView() {
    if (this.activityService.activityOpenedFromTodo) {
      this.uiService.showRightPane = false;
      this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView);
      this.activityService.activityOpenedFromTodo = false;
    }
  }

  private phoneCallEvents() {
    this.events.observe('phoneCallActivityDeleted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.handleTodoItemTransactions(activity);
    });

    this.events.observe('phoneCallActivityCompleted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.handleTodoItemTransactions(activity);
      this.resetRightSideView();
    });

    this.events.observe('phoneCallActivityIsUpdated').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.replaceUpdatedActivityOnChange(activity);
    });
  }

  private timeOffEvents() {
    this.events.observe('timeOffActivityDeleted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.handleTodoItemTransactions(activity);
    });

    this.events.observe('timeOffActivityReopen').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.handleActivityReopened(activity);
    });

    // isSubmitted: timeoff is submitted.
    this.twoArgumentEventSubscriptions.push(...this.events.subscribe('timeOffActivityIsUpdated', (activity, isSubmitted) => {
      if (isSubmitted && isSubmitted === true) {
        this.handleTodoItemTransactions(activity);
        this.resetRightSideView();
      } else {
        this.replaceUpdatedActivityOnChange(activity);
      }
    }));
  }

  private allocationOrdersEvents() {
    this.events.observe('allocationOrderActivityDeleted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.handleTodoItemTransactions(activity);
    });

    this.events.observe('allocationOrderActivityCompleted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.handleTodoItemTransactions(activity);
      this.resetRightSideView();
    });

    this.events.observe('allocationOrderActivityOpen').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      if (activity) {
        this.openActivityDetails(activity);
      }
    });

    this.events.observe('allocationOrderActivityIsUpdated').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.replaceUpdatedActivityOnChange(activity);
    });
  }

  private messageEvents() {
    this.twoArgumentEventSubscriptions.push(...this.events.subscribe('messageActivityDeleted', (activity, isFromParentActivity) => {
      this.handleTodoItemTransactions(activity, this.validateShouldResetRightSideView(isFromParentActivity));
    }));

    this.events.observe('messageActivitySent').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.handleTodoItemTransactions(activity);
      this.resetRightSideView();
    });

    this.events.observe('messageActivityTimeIsUpdated').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.replaceUpdatedActivityOnChange(activity);
    });
  }

  private surgeryOrderEvents() {
    this.twoArgumentEventSubscriptions.push(...this.events.subscribe('surgeryOrderActivityDeleted', (activity, isFromParentActivity) => {
      this.handleTodoItemTransactions(activity, this.validateShouldResetRightSideView(isFromParentActivity));
    }));
    this.twoArgumentEventSubscriptions.push(...this.events.subscribe('procedureTrackerActivityDeleted', (activity, isFromParentActivity) => {
      this.handleTodoItemTransactions(activity, this.validateShouldResetRightSideView(isFromParentActivity));
    }));

    this.events.observe('ProcedureTrackerActivityCompleted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.handleTodoItemTransactions(activity);
      this.resetRightSideView();
    });
    this.events.observe('surgeryOrderActivityCompleted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.handleTodoItemTransactions(activity);
      this.resetRightSideView();
    });

    this.events.observe('surgeryOrderActivityTimeIsUpdated').pipe(takeUntil(this.ngDestroy$)).subscribe((activity: any) => {
      this.replaceUpdatedActivityOnChange(activity);
    });
  }

  private replaceUpdatedActivityOnChange(activity: any) {
    const index = this.allTodoItems.findIndex(o => o.ID === activity?.ID);
    if (index > -1) {
      this.allTodoItems[index] = activity;
    }
    this.refreshTodoItems();
  }

  private refreshTodoItems() {
    this.applyCurrentTodoView();
  }

  /**
   * OMNI-60715: Single source of truth for rendering the To-Do list after any reload.
   * Re-applies the current view — an active search and/or a selected type filter — so a
   * reload (e.g. opening a message, which fires a refresh) never silently drops the search
   * and reverts to showing all items. Previously each reload path only re-applied the filter
   * when a type chip was selected, missing the active-search case under the 'All' chip.
   */
  private applyCurrentTodoView() {
    const hasActiveSearch = !isEmpty(this.searchText) && this.showSearch;
    const typeFilterSelected = !!this.filterOptions?.find(item => item.id === 'all' && !item.selected);
    if (hasActiveSearch || typeFilterSelected) {
      this.onFilterClick();
    } else {
      this.filteredTodoItems = this.sortItems(this.allTodoItems);
      this.todoItems$.next(this.filteredTodoItems);
    }
  }

  handleActivityReopened(activity) {
    if (activity) {
      const dateAdjustedWithOfflineDataDuration = new Date(new Date((new Date().setDate(new Date().getDate() - this.authService.user.offlineDataDuration))).setHours(0, 0, 0, 0));
      const todayStart = new Date(new Date().setHours(0, 0, 0, 0));
      if (this.todoService.isValidated(activity, dateAdjustedWithOfflineDataDuration, todayStart)) {
        const index = this.allTodoItems.findIndex(o => o.ID === activity?.ID);
        if (index > -1) {
          this.allTodoItems[index] = activity;
        } else {
          this.allTodoItems.push(activity);
        }
        this.refreshTodoItems();
      }
    }
  }

  handleTodoItemTransactions(activity: Activity, shouldResetRightSideView: boolean = true) {
    this.initTodoItems();
    this.onFilterClick();
  }

  private validateShouldResetRightSideView(isFromParentActivity: any): boolean {
    // returning true means, Reset, this is default behaviour.
    if (isFromParentActivity) {
      // if isFromParentActivity is passed as an event argument
      if (isFromParentActivity === true) {
        return false;
      } else {
        return true;
      }
    }
    // if isFromParentActivity it self is not available.
    return true;
  }

  initFilterOptions(translatedglobaltext) {
    this.filterOptions = [{
      id: 'all',
      name: this.translate.instant('ALL'),
      selected: true,
    }]
    if (this.authService.hasFeatureAction(FeatureActionsMap.SHOW_SUGGESTED_MEETINGS) ||
      this.authService.hasFeatureAction(FeatureActionsMap.SHOW_SUGGESTED_WECOM_MESSAGES) ||
      this.authService.hasFeatureAction(FeatureActionsMap.SHOW_SUGGESTED_TASKS)) {
      this.filterOptions.push({
        id: 'Suggested',
        name: this.translate.instant('SUGGESTED'),
        selected: false,
      });
     }
    this.filterOptions.push({
      id: ActivityType.Appointment,
      name: this.translate.instant('MEETINGS'),
      selected: false,
    })
    if (this.authService.hasFeatureAction(FeatureActionsMap.FOLLOW_UP_ACTION_ACTIVITY) || this.authService.hasFeatureAction(FeatureActionsMap.SCIENTIFIC_FOLLOW_UP_TASK) || this.authService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_MANAGEMENT_TASK)) {
      this.filterOptions.push({
        id: ActivityType.FollowUp,
        name: this.translate.instant('FOLLOW_UP_ACTIONS'),
        selected: false,
      });
    }
    if (this.authService.user.hasProcedureLog) {
      this.filterOptions.push({
        id: ActivityType.SurgeryOrder,
        name: this.translate.instant('PROCEDURE_LOGS'),
        selected: false,
      });
    }
    if (this.authService.hasFeatureAction(FeatureActionsMap.PHONECALL_ACTIVITY)) {
      this.filterOptions.push({
        id: ActivityType.PhoneCall,
        name: this.translate.instant('PHONE_CALLS'),
        selected: false,
      });
    }
    if (this.authService.hasFeatureAction(FeatureActionsMap.MESSAGE_ACTIVITY)) {
      this.filterOptions.push({
        id: ActivityType.Email,
        name: this.translate.instant('MESSAGES'),
        selected: false,
      });
    }
    if (this.authService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE)) {
      this.filterOptions.push({
        id: ActivityType.CaseIntake,
        name: this.translate.instant('CUSTOMER_INQUIRY_WITH_TEXT', { globalCustomerText: translatedglobaltext }),
        selected: false,
      });
    }
    if (this.authService.hasFeatureAction(FeatureActionsMap.ALLOCATION_TOOL)) {
      this.filterOptions.push({
        id: ActivityType.Sample,
        name: this.translate.instant('ALLOWCATION_ORDERS'),
        selected: false,
      });
    }
    if (this.authService.hasFeatureAction(FeatureActionsMap.TIME_OFF_TOOL)) {
      this.filterOptions.push({
        id: ActivityType.TimeOffRequest,
        name: this.translate.instant('TIME_OFF'),
        selected: false,
      });
    } if (this.authService.hasFeatureAction(FeatureActionsMap.ORDER_MANAGEMENT)) {
      this.filterOptions.push({
        id: ActivityType.Order,
        name: this.translate.instant('ACCOUNT_TIMELINE_OPTION_ORDERS'),
        selected: false,
      });
    }
    if (this.authService.hasFeatureAction(FeatureActionsMap.RECIEPTS_TAB)) {
      this.filterOptions.push({
        id: 'Shipment',
        name: this.translate.instant('SHIPMENTS'),
        selected: false,
      });
    }
    if (this.authService.hasFeatureAction(FeatureActionsMap.ALLOCATION_TRANSFER)) {
      this.filterOptions.push({
        id: 'Transfer',
        name: this.translate.instant('TRANSFERS'),
        selected: false,
      });
    }
    if (this.authService.hasFeatureAction(FeatureActionsMap.COACHING_TOOL)) {
      this.filterOptions.push({
        id: 'Coaching',
        name: this.translate.instant('COACHING'),
        selected: false,
      });
    }
    if (this.authService.hasFeatureAction(FeatureActionsMap.KIT_BOOKING)) {
      this.filterOptions.push({
        id: ActivityType.SetBooking,
        name: this.translate.instant('KIT_BOOKINGS'),
        selected: false,
      });
    }

    this.allPossibleFilterOptions = cloneDeep(this.filterOptions);
  }

  initTodoItems() {
    this.allTodoItems = this.todoService.filterIncompleteActivities();
    this.allTodoItems.forEach(item => item['date'] = item.scheduledStart)
    this.getPendingFollowupActions();
    this.getPendingSalesOrderActions();
    this.getPendingCoachingActivities();
    this.getPendingShipmentsAndTransfers();
    this.applyCurrentTodoView();
    this.updateFilterOptionsBasedOnData();
  }

  private isSuggestedItem(item: any): boolean {
    return (item.type === ActivityType.FollowUp && item['planType'] === FOLLOW_UP_TYPE.SUGGESTED) ||
           (item.type == ActivityType.Email && item['indskr_recommendedmessage']) ||
           (item.type == ActivityType.Appointment && item['indskr_suggest']);
  }

  private updateFilterOptionsBasedOnData() {
    if (!this.filterOptions) {
      return;
    }
    this.filterOptions = [this.allPossibleFilterOptions[0]];

    for (let i = 1; i < this.allPossibleFilterOptions.length; i++) {
      const option = this.allPossibleFilterOptions[i];
      if (option.id === 'Suggested') {
        const suggestedItemCount = this.allTodoItems.filter(item => this.isSuggestedItem(item)).length;
        if (suggestedItemCount > 0) {
          this.filterOptions.push(option);
        }
      } else {
        const itemCount = this.allTodoItems.filter(item => item.type === option.id).length;
        if (itemCount > 0) {
          this.filterOptions.push(option);
        }
      }
    }
    const noSelectedFilterOptions = this.filterOptions.filter(item => item.selected).length === 0;
    if (noSelectedFilterOptions) {
     this.onFilterClick();
    }
  }

  initAllSectionHeader() {
    this.pinnedSectionHeader = {
      id: 'pinned-items-header',
      title: this.translate.instant('PINNED'),
      controls: []
    }
  }

  private getPendingShipmentsAndTransfers() {
    if ((this.authService.hasFeatureAction(FeatureActionsMap.RECIEPTS_TAB)
      || this.authService.hasFeatureAction(FeatureActionsMap.ALLOCATION_TRANSFER))) {
      const allPendingActions = this.allocFeatureService.pendingShipments;
      allPendingActions.forEach(item => {
        if ((item as IAllocationShipmentAndTransferBase).indskr_shipmentdate) {
          const shipmentDate = (item as IAllocationShipmentAndTransferBase).indskr_shipmentdate;
          item['date'] = shipmentDate ? new Date(shipmentDate) : null;
        }
        item['type'] = item.indskr_transfertype === TransferType.AllocationTransfer ? 'Transfer' : 'Shipment';
      });
      this.allTodoItems.push(...allPendingActions);
    }
  }


  private getPendingFollowupActions() {
    if (this.authService.hasFeatureAction(FeatureActionsMap.FOLLOW_UP_ACTION_ACTIVITY) 
      || this.authService.hasFeatureAction(FeatureActionsMap.SCIENTIFIC_FOLLOW_UP_TASK)
      || this.authService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_MANAGEMENT_TASK)
      || this.authService.hasFeatureAction(FeatureActionsMap.SHOW_SUGGESTED_TASKS)
    ) {
      const pendingFollowups = this.activityService.getAllPendingFollowupActions();
      this.allTodoItems.push(...pendingFollowups);
    }
  }

  private getPendingSalesOrderActions() {
    if (this.authService.hasFeatureAction(FeatureActionsMap.ORDER_MANAGEMENT)) {
      const pendingSalesOrders = this.todoService.getPendingSalesOrder();
      pendingSalesOrders.forEach(item => item['date'] = item.scheduledStart);
      this.allTodoItems.push(...pendingSalesOrders);
    }
  }

  private getPendingCoachingActivities() {
    if (this.authService.hasFeatureAction(FeatureActionsMap.COACHING_TOOL)) {
      const pendingCoachingActivities = this.coachingActivities;
      pendingCoachingActivities.forEach(item => {
        item['date'] = item.statuscode === 548910001 ? new Date(item.indskr_dateforreview) : new Date(item.indskr_shareddate);
        item['type'] = 'Coaching';
      });
      this.allTodoItems.push(...pendingCoachingActivities);
    }
  }


  isPinned(id: string, type?: PlanTabActivityType) {
    let index = this.todoService.pinnedItems.findIndex(item => item.id === id);
    return index >= 0;
  }

  initPinnedItemsData() {

  }

  sortItems(items) {
    return items.sort((a, b) => {
      if (a.date > b.date) {
        return -1;
      } else if (a.date < b.date) {
        return 1;
      } else {
        return 0;
      }
    })
  }

  public getActivityMainCard(activity) {
    const clickhandler = (id: string, event, specificTarget) => {
      this.activityService.activityOpenedFromTodo = true;
      let foundActivity = this.activityService.activities.find(item => item.ID === id);
      if (foundActivity) {
        this.openActivityDetails(foundActivity);
        return;
      }
      if (activity.type === 'Coaching') {
        this.coachingClickHandler(activity)
      } else if (activity.type === 'Shipment' || activity.type === 'Transfer') {
        this.openAllocationShipment(id);
      }
    }
    return this.getActivityMainCardModel(activity, clickhandler);
  }

  getActivityMainCardModel(activity, clickHandler): MainCardViewDataModel {
    switch (activity.type) {
      case ActivityType.Appointment:
        return this.getAppointmentMainCardModel(activity, clickHandler);
      case ActivityType.FollowUp:
        return this.getFollowupMainCardModel(activity, clickHandler);
      case ActivityType.SurgeryOrder:
        return this.getProcedureLogMainCardModel(activity, clickHandler);
      case ActivityType.ProcedureTracker:
        return this.getProcedureTrackerMainCardModel(activity, clickHandler);
      case ActivityType.Email:
        return this.getMessageMainCardModel(activity, clickHandler);
      case ActivityType.PhoneCall:
        return this.getPhoneCallMainCardModel(activity, clickHandler);
      case ActivityType.CaseIntake:
        return this.getCustomerInquiryMainCardModel(activity, clickHandler);
      case ActivityType.Sample:
        return this.getAllocationOrderMainCardModel(activity, clickHandler);
      case ActivityType.TimeOffRequest:
        return this.getTimeOffMainCardModel(activity, clickHandler);
      case ActivityType.Order:
        return this.getSalesOrderMainCardModel(activity, clickHandler);
      case ActivityType.SetBooking:
        return this.getSetBookingMainCardModel(activity as SetBookingActivity, clickHandler);
      case 'Coaching':
        return this.getCoachingMainCardModel(activity, clickHandler);
      case 'Transfer':
      case 'Shipment':
        return this.getPendingActionShipmentMainCardModel(activity, clickHandler);
    }
  }

  coachingClickHandler(coaching) {
    this.activityOpenedFromTodo.emit(true); // Emit that activity was opened from Todo
    this.onCoachingReportSelection(coaching);
    this.coachingReportService.activeTab = 'myCoaching';
  }

  async onCoachingReportSelection(report: Report) {
    this.coachingReportService.coachingViewtype = COACHING_VIEW_TYPE.FROM_HOMESCREEN;
    if ((report.statuscode === 548910001 || report.statuscode === 548910002 || report.statuscode === 548910003) && !this.coachingReportService.isOffline(report)) {
      await this.coachingReportService.checkCoachingOnline(report);
    }

    this.coachingReportService.selectedCoachingPlanTab = report;
    this.coachingReportService.selectedReport.next(report);
    this.uiService.showNewActivity = false;
    this.uiService.showRightPane = true;
    this.uiService.prevView = this.uiService.activeView; // need to check in mobile
    this.uiService.activeView = 'ActivitiesPageRightPaneNav';
    this.navService.setChildNavRoot(PageName.CoachingDetailsComponent, PageName.CoachingDetailsComponent, PageName.GoAppActivitiesPageComponent, { from: 'AgendaView' });
  }

  getPendingActionShipmentMainCardModel(item: IAllocationShipment | IAllocationTransfer | IAllocationAdjustment, clickHandler) {
    let date: Date;
    if ((item as IAllocationShipmentAndTransferBase).indskr_shipmentdate) {
      date = new Date((item as IAllocationShipmentAndTransferBase).indskr_shipmentdate) ?? null;
    } else if ((item as IAllocationAdjustment).indskr_adjustmentdate) {
      date = new Date((item as IAllocationAdjustment).indskr_adjustmentdate) ?? null;
    }

    return {
      id: item.indskr_usershipmentallocation_v2id,
      fixedHeight: true,
      isExpandable: true,
      isExpanded: true,
      expandableViewType: 'activitiesList',
      expandableData: item,
      expandHeight: this.itemExpandHeight,
      noSeparationLine: false,
      isSelected: (this.allocFeatureService.selectedShipment && item.indskr_usershipmentallocation_v2id === this.allocFeatureService.selectedShipment.indskr_usershipmentallocation_v2id),
      primaryTextRight: `${this.getShipmentName(item)} ${item.indskr_shipmentnumber}`,
      primaryTextLeft: item.indskr_skuname || item.at_indskr_skuname,
      secondaryTextRight: item.indskr_transfertype === TransferType.AllocationTransfer ? `${this.getFormattedDate(date)} ${this.getTransferToFromName(item as IAllocationTransfer)}` : this.getFormattedDate(date),
      showArrow: false,
      showIcon: true,
      iconName: this.getTransferIconPath(item as IAllocationShipment),
      clickHandler: clickHandler,
      type: item.indskr_transfertype ? item.indskr_transfertype : TransferType.AllocationShipment,
      date: date,
      wordWrap: true
    };
  }

  getCoachingMainCardModel(activity: Report, clickHandler): MainCardViewDataModel {
    return {
      id: activity._id,
      fixedHeight: true,
      isExpandable: true,
      expandableViewType: 'activitiesList',
      expandableData: activity,
      expandHeight: this.itemExpandHeight,
      isSelected: (this.coachingReportService.selectedCoachingPlanTab && this.coachingReportService.selectedCoachingPlanTab._id == activity._id),
      primaryTextLeft: this.coachingReportService.makeStatus(activity.statuscode),
      primaryTextRight: this.translate.instant('COACHING') + ' - ' + activity.created_by,
      secondaryTextRight: this.coachingReportService.getTertiaryInfo(activity, {
        value: activity.statuscode === 548910001 ? 'indskr_dateforreview' : 'indskr_shareddate'
      }),
      showArrow: false,
      showIcon: true,
      iconName: 'indegene-coaching-icon',
      clickHandler: clickHandler,
      type: 'coaching',
      wordWrap: true,
      date: activity.statuscode === 548910001 ? new Date(activity.indskr_dateforreview) : new Date(activity.indskr_shareddate)
    };
  }

  private buildBaseActivityCard(activity: Activity, clickHandler, overrides: Partial<MainCardViewDataModel> = {}): MainCardViewDataModel {
    return {
      id: activity.ID,
      fixedHeight: true,
      isExpandable: true,
      isExpanded: activity.expanded,
      expandableViewType: 'activitiesList',
      expandableData: activity,
      expandHeight: this.itemExpandHeight,
      isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
      showArrow: false,
      showIcon: true,
      iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
      clickHandler: clickHandler,
      type: activity.type,
      date: activity.scheduledStart,
      wordWrap: true,
      ...overrides,
    };
  }

  private getDateWithTimeRange(activity: Activity): string {
    return this.getFormattedDateForIncompleteActivities(activity.scheduledStart) + ' | ' + this.dateTimeFormatService.formatDate(activity.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment) + ' - ' + this.dateTimeFormatService.formatDate(activity.scheduledEnd, this.dateTimeFormatService.timeFormatSelected.segment);
  }

  private getDateWithStartTime(activity: Activity): string {
    return this.getFormattedDateForIncompleteActivities(activity.scheduledStart) + ' | ' + this.dateTimeFormatService.formatDate(activity.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment);
  }

  private getSalesOrderMainCardModel(activity: Activity, clickHandler): MainCardViewDataModel {
    return this.buildBaseActivityCard(activity, clickHandler, {
      primaryTextLeft: this.getDateWithTimeRange(activity),
      primaryTextRight: this.translate.instant('NEW_ACTIVITY_SALES_ORDER') + ' - ' + activity.subject,
      secondaryTextRight: (!(activity as OrderActivity).accountId) ? this.translate.instant('NO_ACCOUNT') : (activity as OrderActivity).accountNameString,
    });
  }

  private getAppointmentMainCardModel(activity: Activity, clickHandler): MainCardViewDataModel {
    return this.buildBaseActivityCard(activity, clickHandler, {
      noSeparationLine: false,
      primaryTextLeft: this.getDateWithTimeRange(activity),
      primaryTextRight: activity.subject == 'Meeting' ? this.translate.instant('MEETING') : (this.authService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT) && activity.subject == 'Visit') ? this.translate.instant('VISIT') : activity.subject,
      secondaryTextRight: (!activity.location || activity.location == 'nan') ? this.translate.instant('NO_LOCATION') : (activity.location == 'No Location' ? this.translate.instant('NO_LOCATION') : activity.location),
    });
  }

  private getFollowupMainCardModel(activity, clickHandler): MainCardViewDataModel {
    let setFollowUpTime = new Date();
    setFollowUpTime.setHours(24);
    setFollowUpTime.setMinutes(0);
    return this.buildBaseActivityCard(activity, clickHandler, {
      primaryTextLeft: this.getFormattedDateForIncompleteActivities(activity.scheduledStart) + ' | ' + this.dateTimeFormatService.formatDate(setFollowUpTime, this.dateTimeFormatService.timeFormatSelected.segment),
      primaryTextRight: activity.subject == 'Follow-up Action' ? this.translate.instant('FOLLOW_UP_ACTION') : activity.subject,
      secondaryTextRight: this.getActivitySecondaryTextStringForFollowup(activity as FollowUpActivity),
    });
  }

  private getProcedureLogMainCardModel(activity, clickHandler): MainCardViewDataModel {
    return this.buildBaseActivityCard(activity, clickHandler, {
      primaryTextLeft: this.getDateWithTimeRange(activity),
      primaryTextRight: activity.subject,
      secondaryTextRight: this.getSecondaryInfoProcedureLog(activity),
    });
  }

  private getProcedureTrackerMainCardModel(activity, clickHandler): MainCardViewDataModel {
    return this.buildBaseActivityCard(activity, clickHandler, {
      primaryTextLeft: this.getDateWithTimeRange(activity),
      primaryTextRight: activity.subject,
      secondaryTextRight: this.getSecondaryInfoProcedureTracker(activity),
    });
  }

  private getPhoneCallMainCardModel(activity, clickHandler): MainCardViewDataModel {
    return this.buildBaseActivityCard(activity, clickHandler, {
      primaryTextLeft: this.getDateWithStartTime(activity),
      primaryTextRight: this.activityService.getActivitysubject(activity),
      secondaryTextRight: ((activity as PhoneActivity).selectedMobileNumber == "" || (activity as PhoneActivity).selectedMobileNumber == null || (activity as PhoneActivity).selectedMobileNumber == undefined) ? this.translate.instant('NO_CONTACT_NUMBER') : (activity as PhoneActivity).selectedMobileNumber,
    });
  }

  private getMessageMainCardModel(activity, clickHandler): MainCardViewDataModel {
    return this.buildBaseActivityCard(activity, clickHandler, {
      primaryTextLeft: this.getFormattedDateForIncompleteActivities(activity.scheduledStart) + ' | ' + this.emailService.setTimeForMessages(activity as EmailActivity),
      primaryTextRight: this.emailService.setPrimaryTextRightForMessages(activity as EmailActivity),
      secondaryTextRight: this.emailService.setSecondaryTextForMessages(activity as EmailActivity) + ' ' + this.emailService.setSecondaryTextTwoForMessages(activity as EmailActivity),
    });
  }

  private getCustomerInquiryMainCardModel(activity, clickHandler): MainCardViewDataModel {
    let viewData: MainCardViewDataModel = this.buildBaseActivityCard(activity, clickHandler, {
      expandableViewType: 'customer_inquiry',
      primaryTextLeft: this.getDateWithStartTime(activity),
      primaryTextRight: (activity as CaseActivity).caseName,
    });
    if ((activity as CaseActivity)._case_stage_value) {
      viewData.secondaryTextRight = this.activityService.getCaseState((activity));
      viewData.secondaryTextRightTwo = ((activity as CaseActivity)._case_contact) ? (activity as CaseActivity)._case_contact.fullName : ((activity as CaseActivity)._case_trans_customer_name && (activity as CaseActivity)._case_trans_customer_name != Utility.globalCustomerText) ? (activity as CaseActivity)._case_trans_customer_name : `${this.translate.instant('NO')} ${this.utilityService.globalCustomerText}`;
    } else {
      viewData.secondaryTextRight = ((activity as CaseActivity)._case_contact) ? (activity as CaseActivity)._case_contact.fullName : ((activity as CaseActivity)._case_trans_customer_name && (activity as CaseActivity)._case_trans_customer_name != Utility.globalCustomerText) ? (activity as CaseActivity)._case_trans_customer_name : `${this.translate.instant('NO')} ${this.utilityService.globalCustomerText}`;
    }
    return viewData;
  }

  private getAllocationOrderMainCardModel(activity, clickHandler): MainCardViewDataModel {
    return this.buildBaseActivityCard(activity, clickHandler, {
      primaryTextLeft: this.getDateWithStartTime(activity),
      primaryTextRight: (activity as SampleActivity).orderId ? this.translate.instant('ALLOWCATION_ORDER') + ' - ' + (activity as SampleActivity).orderId : this.translate.instant('ALLOWCATION_ORDER'),
      secondaryTextRight: (!(activity as SampleActivity).contactName) ? this.translate.instant('NO_CONTACT') : (activity as SampleActivity).contactName,
      isSrcAttribute: true,
      iconName: this.activityService.getActivityIcon(activity),
    });
  }

  private getTimeOffMainCardModel(activity, clickHandler): MainCardViewDataModel {
    let setTimeOffTime = new Date();
    let setTimeOffStartTime = new Date();
    let setTimeOffEndTime = new Date();
    let formattedTimeOffTimeText: string = '';
    let tot: TimeOffActivity = <TimeOffActivity>activity;
    if (activity.type === ActivityType.TimeOffRequest) {
      setTimeOffTime.setTime(activity.scheduledStart.getTime());
      switch (tot.durationType) {
        case 'All Day':
          setTimeOffTime.setHours(24);
          setTimeOffTime.setMinutes(0);
          formattedTimeOffTimeText = this.dateTimeFormatService.formatDate(setTimeOffTime, this.dateTimeFormatService.timeFormatSelected.segment); // all day format
          break;
        case 'Half Day':
          setTimeOffTime.setMinutes(0);
          (activity.scheduledStart.getHours() < 12) ? setTimeOffTime.setHours(24) : setTimeOffTime.setHours(12);
          formattedTimeOffTimeText = this.dateTimeFormatService.formatDate(setTimeOffTime, this.dateTimeFormatService.timeFormatSelected.segment); // half day format
          break;
        case 'Hourly':
          setTimeOffStartTime.setTime(activity.scheduledStart.getTime());
          setTimeOffEndTime.setTime(activity.scheduledEnd.getTime());
          // Check half day event again because there is no payload related to half day during initialization of agenda list.
          if (activity.scheduledStart.getHours() == 0 && activity.scheduledStart.getMinutes() == 0 && activity.scheduledEnd.getHours() == 11 && activity.scheduledEnd.getMinutes() == 59 ||
            activity.scheduledStart.getHours() == 12 && activity.scheduledStart.getMinutes() == 0 && activity.scheduledEnd.getHours() == 23 && activity.scheduledEnd.getMinutes() == 59) {
            setTimeOffTime.setMinutes(0);
            (activity.scheduledStart.getHours() < 12) ? setTimeOffTime.setHours(24) : setTimeOffTime.setHours(12);
            formattedTimeOffTimeText = this.dateTimeFormatService.formatDate(setTimeOffTime, this.dateTimeFormatService.timeFormatSelected.segment); // half day format
          } else {
            formattedTimeOffTimeText = this.dateTimeFormatService.formatDate(setTimeOffStartTime, this.dateTimeFormatService.timeFormatSelected.segment) + ' - ' + this.dateTimeFormatService.formatDate(setTimeOffEndTime, this.dateTimeFormatService.timeFormatSelected.segment); // hourly format
          }
          break;
        default:
          console.log('Unhandled switch case statement');
          break;
      }
    }
    return this.buildBaseActivityCard(activity, clickHandler, {
      primaryTextLeft: this.getFormattedDateForIncompleteActivities(activity.scheduledStart) + ' | ' + formattedTimeOffTimeText,
      primaryTextRight: activity.subject == 'Time Off' ? this.translate.instant('TIME_OFF') : activity.subject,
      secondaryTextRight: activity.reason ? activity.reason : this.translate.instant('NO_REASON'),
      isConflicting: activity.conflictingActivityIds instanceof Map && activity.conflictingActivityIds.size > 0 ? true : false,
    });
  }

  private getSetBookingMainCardModel(activity: SetBookingActivity, clickHandler): MainCardViewDataModel {
    return this.buildBaseActivityCard(activity, clickHandler, {
      primaryTextLeft: this.getFormattedDateForIncompleteActivities(activity.scheduledStart) + ' | ' + this.dateTimeFormatService.formatDate(activity.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment) + ' - ' + this.dateTimeFormatService.formatDate(activity.scheduledEnd, this.dateTimeFormatService.timeFormatSelected.segment),
      primaryTextRight: activity.subject,
      secondaryTextRight: this.secInfoConfigDataService.isKitBookingSecInfoConfigured
        ? this.secInfoConfigDataService.getSecondaryInfoFormatedTextForKitBooking(activity, SecondaryInfoEntityName.Kitbooking)
        : activity.statusString,
    });
  }

  public getFormattedDateForIncompleteActivities(value) {
    return this.datePipe.transform(value, this.dateTimeFormatService.date, undefined, this.translate.currentLang);
  }

  private getTransferToFromName(shipment: IAllocationTransfer | IAllocationShipment) {
    const transferTargetName = shipment.userFullName || shipment.warehouseFullName || '';
    return shipment.ownerId === this.authService.user.xSystemUserID ? this.translate.instant('TO') + ` ${transferTargetName}` : this.translate.instant('FROM') + ` ${shipment.ownerFullName}`;
  }

  public getFormattedDate(value) {
    return `${this.datePipe.transform(value, 'MMM dd', undefined, this.translate.currentLang)}`;
  }

  private getTransferIconPath(shipment: IAllocationTransfer | IAllocationShipment) {
    if (shipment.indskr_transfertype === TransferType.AllocationTransfer) {
      return shipment.ownerId === this.authService.user.xSystemUserID ? 'indegene-assets/imgs/transfer_To.svg' : 'indegene-assets/imgs/transfer_From.svg'
    } else if (shipment.indskr_transfertype !== TransferType.AllocationAdjustment) {
      return 'indegene-assets/imgs/transfer_down.svg';
    }
  }

  private getShipmentName(item: IAllocationShipment | IAllocationTransfer | IAllocationAdjustment) {
    if (item.indskr_transfertype === TransferType.AllocationTransfer) {
      return this.translate.instant('TRANSFER_NUMBER');
    }
    return this.translate.instant('AL_SHIPMENT_NUM');
  }

  private openAllocationShipment(id: string) {
    this.activityOpenedFromTodo.emit(true); // Emit that activity was opened from Todo
    const foundItem = this.allocFeatureService.pendingShipments.find(item => item.indskr_usershipmentallocation_v2id === id);

    if (foundItem) {
      this.allocFeatureService.selectedShipment = foundItem as IAllocationShipment;
      this.allocFeatureService.selectedShipmentAtHome = this.allocFeatureService.selectedShipment;

      this.activityService.selectedActivity = undefined;
      this.activityService.selectedActivityAtHome = undefined;
      this.navService.setChildNavRoot(PageName.AllocationShipmentDetailsComponent, PageName.AllocationShipmentDetailsComponent, PageName.GoAppActivitiesPageComponent, { masterPage: PageName.GoAppHomeComponent });
      this.uiService.prevView = this.uiService.activeView;
      this.uiService.activeView = 'AllocationShipment';
      this.uiService.showRightPane = true;
      this.shipmentService.fromAgendaPlanTab = true;
    }
  }

  private getActivitySecondaryTextStringForFollowup(activity: FollowUpActivity): string {
    if (activity) {
      return this.followUpDataService.getActivitySecondaryTextStringForFollowup(activity);
    }
  }

  private getSecondaryInfoProcedureLog(activity: SurgeryOrderActivity): string {
    if (activity.indskr_noprocedureday) {
      return this.translate.instant('NO_PROCEDURE_DAY');
    } else {
      return (!activity.accountId) ? this.translate.instant('NO_ACCOUNT') : activity.accountNameString;
    }
  }

  private getSecondaryInfoProcedureTracker(activity: ProcedureTrackerActivity): string {
    return (!activity.accountId) ? this.translate.instant('NO_ACCOUNT') : activity.accountNameString;
  }

  openActivityDetails(activity: Activity) {
    let foundActivity = this.activityService.getActivityByID(activity.ID);
    this.coachingReportService.selectedCoachingPlanTab = undefined;

    this.activityService.selected = foundActivity || activity;
    this.activityOpenedFromTodo.emit(true); // Emit that activity was opened from Todo
    this.setupPlanTabAndActivityTracking(foundActivity || activity);

    // Handle Case Intake special case
    if (activity.type === ActivityType.CaseIntake) {
      this.prepareCaseActivity(activity);
    }

    this.activityDataService.updateActivityDetails(activity);

    // Navigate based on activity type if selected activity exists
    if (this.activityService.selectedActivity) {
      this.navigateToActivityDetail(this.activityService.selectedActivity);
      this.activityService.selectedActivityAtHome = this.activityService.selectedActivity;
    }
  }

  private setupPlanTabAndActivityTracking(activity: Activity) {
    if (!this.uiService.activitiesPagePlanTabSelectedPlan) {
      this.uiService.activitiesPagePlanTabSelectedPlan = 'planTabTodo';
    }

    if (activity?.ID) {
      this.todoService.lastOpenActivityType = activity.type;
      this.todoService.lastOpenActivityID = activity.ID;
    }
  }

  private prepareCaseActivity(activity: Activity) {
    if (!activity.ID) {
      activity.ID = (activity as CaseActivity).offline_ID;
      (activity as CaseActivity)._case_status_value = "Open";
    }
    this.activityDataService.fetchCaseDetails(activity);
  }

  private navigateToActivityDetail(selectedActivity: Activity) {
    // Setup common UI state first
    this.setupUIStateForActivityDetail();

    // Handle navigation based on activity type
    switch (selectedActivity.type) {
      case ActivityType.Appointment:
        this.navService.setChildNavRoot(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent,
          PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppHomeComponent });
        break;

      case ActivityType.FollowUp:
        this.handleFollowUpNavigation(selectedActivity as FollowUpActivity);
        break;

      case ActivityType.Email:
        this.handleEmailNavigation(selectedActivity as EmailActivity);
        break;

      case ActivityType.SurgeryOrder:
      case ActivityType.ProcedureTracker:
        this.navService.setChildNavRoot(PageName.SurgeryOrderDetailsComponent, PageName.SurgeryOrderDetailsComponent,
          PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppHomeComponent, activity: selectedActivity });
        break;

      case ActivityType.PhoneCall:
        this.navService.setChildNavRoot(PageName.PhoneCallDetailsComponent, PageName.PhoneCallDetailsComponent,
          PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppHomeComponent });
        break;

      case ActivityType.TimeOffRequest:
        this.handleTimeOffNavigation(selectedActivity);
        break;

      case ActivityType.Sample:
        this.navService.setChildNavRoot(PageName.NewSampleActivityComponent, PageName.NewSampleActivityComponent,
          PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppHomeComponent });
        break;

      case ActivityType.CaseIntake:
        this.handleCaseIntakeNavigation(selectedActivity);
        break;

      case ActivityType.Order:
        this.navService.setChildNavRoot(PageName.OrderDetailsComponent, PageName.OrderDetailsComponent,
          PageName.GoAppActivitiesPageComponent, { from: 'AgendaView', activity: selectedActivity });
        break;
      case ActivityType.SetBooking:
        this.navService.setChildNavRoot(PageName.SetBookingActivityDetailsComponent, PageName.SetBookingActivityDetailsComponent,
          PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppHomeComponent, activity: selectedActivity, initFetchData: true });
        break;
    }
  }

  private setupUIStateForActivityDetail() {
    this.uiService.activeView = 'ActivitiesPageRightPaneNav';
    this.uiService.showNewActivity = false;
    this.uiService.showRightPane = true;
  }

  private handleFollowUpNavigation(activity: FollowUpActivity) {
    this.events.publish('updateCurrentFollowUpActivity');
    
    const isScientificPlan = activity.scientificPlanId || 
      (activity.planType && activity.planType == FOLLOW_UP_TYPE.SCIENTIFIC_PLAN);
    
    const pageName = isScientificPlan ? PageName.ScientificPlanFollowUpTask : PageName.FollowUpActionDetailComponent;

    this.navService.setChildNavRoot(pageName, pageName, PageName.GoAppActivitiesPageComponent,
      { from: 'AgendaView', activity: activity });
  }

  private handleEmailNavigation(activity: EmailActivity) {
    this.emailService.viewType = EmailViewType.FROM_HOMESCREEN;
    this.emailService.selectedActivity = activity;
    this.navService.setChildNavRoot(PageName.EmailDetailsPageComponent, PageName.EmailDetailsPageComponent,
      PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppActivitiesPageComponent });
  }

  private handleTimeOffNavigation(activity: Activity) {
    this.timeOffService.setSelectedTot(activity as TimeOffActivity);
    this.navService.setChildNavRoot(PageName.TimeOffDetailsComponent, PageName.TimeOffDetailsComponent,
      PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppHomeComponent });
  }

  private handleCaseIntakeNavigation(activity: Activity) {
    try {
      this.caseManagementService.accessedFrom = AccesingMode.AGENDA;
      this.caseManagementService.assignSelectedCase(activity as CaseActivity);
    } catch (error) { }
    this.navService.setChildNavRoot(PageName.CaseManagementDetailComponent, PageName.CaseManagementDetailComponent, 
      PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppHomeComponent });
  }

  onClickSearch(event) {
    this.showSearch = !this.showSearch;
    this.searchText = '';
  }

  clearSearchBar() {
    this.searchText = '';
    this.onFilterClick();
  }

  onSearchInput(event) {
    if (event?.target) {
      const val = event.target.value;
      if (val && val.trim() != '') {
        this.showSearch = true;
        this.searchText = val;
      }
      this.onFilterClick();
    }
  }

  onFilterClick(option?) {
    if (option?.id === 'all') {
      //Clear other selection
      this.filterOptions.forEach((item) => { item.selected = option.id === item.id; })
    } else {
      //Deselect `all` option
      this.filterOptions.find((item) => item.id === 'all').selected = false;
      //Allow multi select
      if (option)
        option.selected = !option.selected;
      //Once all filter options deselect, default 'all' option should be selected
      if (this.filterOptions.filter((item) => item.selected).length === 0) {
        this.filterOptions.find((item) => item.id === 'all').selected = true;
      }
    }

    if (!isEmpty(this.searchText) && this.showSearch) {
      this.filteredTodoItems = this.allTodoItems.filter(activity => {
        if (activity.type === 'Coaching') {
          return (this.translate.instant('COACHING') + ' - ' + activity.created_by + this.coachingReportService.makeStatus(activity.statuscode) + this.coachingReportService.getTertiaryInfo(activity,
            this.coachingReportService.getTertiaryInfo(activity, {
              value: activity.statuscode === 548910001 ? 'indskr_dateforreview' : 'indskr_shareddate'
            })).toLowerCase()).includes(this.searchText.trim().toLowerCase());
        } else if (activity.type === 'Transfer' || activity.type === 'Shipment') {
          let date: Date;
          if ((activity as IAllocationShipmentAndTransferBase).indskr_shipmentdate) {
            date = new Date((activity as IAllocationShipmentAndTransferBase).indskr_shipmentdate);
          } else if ((activity as IAllocationAdjustment).indskr_adjustmentdate) {
            date = new Date((activity as IAllocationAdjustment).indskr_adjustmentdate);
          }
          const dateValue = activity.indskr_transfertype === TransferType.AllocationTransfer ? `${this.getFormattedDate(date)} ${this.getTransferToFromName(activity as IAllocationTransfer)}` : this.getFormattedDate(date)
          return [this.getShipmentName(activity), activity.indskr_shipmentnumber, activity.indskr_skuname, activity.at_indskr_skuname, dateValue].join(' ').toLowerCase().includes(this.searchText.trim().toLowerCase());
        } else
          return this.activityService._checkIfActivityIncludesSearchText(activity, this.searchText);
      });
      this.filteredTodoItems = this.applyTypeFilter(this.filteredTodoItems);
    } else {
      if (this.filterOptions.some((item) => item.id === 'all' && item.selected)) {
        this.initTodoItems();
      } else {
        this.filteredTodoItems = this.applyTypeFilter(this.allTodoItems);
      }
    }

    this.todoItems$.next(this.filteredTodoItems);
    // Scroll to top when filter option is clicked
    if (option && this.todoList) {
      setTimeout(() => {
        this.todoList.element.scrollTop = 0;
        this.todoList.refreshList();
      }, 100);
    }
  }

  private applyTypeFilter(items: any[]): any[] {
    const typesOfActivitiesToFilter = this.filterOptions
      .filter((item) => item.selected)
      .map((item) => item.id);
    if (typesOfActivitiesToFilter.includes('all')) return this.sortItems(items);
    return this.sortItems(items.filter(item => {
      if (typesOfActivitiesToFilter.includes('Suggested') && this.isSuggestedItem(item)) return item;
      if (typesOfActivitiesToFilter.includes(item.type)) return item;
    }));
  }

  ngOnDestroy() {
    this.twoArgumentEventSubscriptions.forEach(subscription => subscription.unsubscribe());
    this.coachingSubscription?.unsubscribe();
    this.ngDestroy$.next(true);
    this.ngDestroy$.complete();
  }

  trackById(index: number, item: any) { return item?.id || item?.ID || index; }
}
